import Image from 'next/image';
import { SlideProps } from '@/types/componentTypes';
import { CarouselCode } from './codeHighlights/CarouselCode';

type CarouselProps = {
  slides: SlideProps[];
};

const Carousel: React.FC<CarouselProps> = ({ slides }) => {
  const imageLoader = ({ src }) => {
    return `${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/${src}`;
  };

  return (
    <>
      <div
        id="carouselExampleAutoplaying"
        className="carousel slide carousel-fade"
        data-bs-touch="true"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          {slides &&
            slides.map((slide, idx: number) => {
              return (
                <div
                  className={
                    idx === 0
                      ? 'd-lg-flex align-items-lg-end carousel-item active d-block'
                      : 'd-lg-flex align-items-lg-end carousel-item'
                  }
                  data-bs-interval="10000"
                  data-bs-pause="true"
                  key={idx}
                >
                  <Image
                    loader={imageLoader}
                    src={slide.src}
                    alt={slide.alt}
                    width={1920}
                    height={1282}
                    className="img-fluid w-100"
                    style={{ objectFit: 'contain' }}
                  />
                  <div className="carousel-caption">
                    <a href="#">
                      <h5>{slide.title}</h5>
                      <span>{slide.text}</span>
                    </a>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="d-flex flex-row align-items-center w-100 justify-content-end">
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleAutoplaying"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>

      <div className="mt-5">
        <h2>Carousel HTML-Code Example</h2>
        <CarouselCode />
      </div>
    </>
  );
};

export default Carousel;
